module.exports = __webpack_public_path__ + "static/media/BodyRelaxationTechniques.40037cd6.mp3";